import { render, staticRenderFns } from "./ClientsEditor.vue?vue&type=template&id=6f7a0479&scoped=true"
import script from "./ClientsEditor.vue?vue&type=script&lang=js"
export * from "./ClientsEditor.vue?vue&type=script&lang=js"
import style0 from "./ClientsEditor.vue?vue&type=style&index=0&id=6f7a0479&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a0479",
  null
  
)

export default component.exports